import React from 'react';
import CoreValueCard from './CoreValueCard';
import type { CoreValue } from '../hooks/useAboutPageData';

interface CoreValuesSectionProps {
  coreValues: CoreValue[];
}

/**
 * CoreValuesSection Component
 * Displays a grid of core value cards
 */
const CoreValuesSection: React.FC<CoreValuesSectionProps> = ({ coreValues }) => {
  return (
    <section className="py-16 px-8 lg:px-12" aria-label="Core values">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {coreValues.map((value) => (
            <CoreValueCard
              key={value.id}
              title={value.title}
              description={value.description}
              imageSrc={value.imageSrc}
              imageAlt={value.imageAlt}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreValuesSection;
